import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center footer">
    <div className="container" />
    <p>
      Quicklist. <small>Anthony Jimenez</small>
    </p>
  </footer>
);

export default Footer;
